
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Modal from '@/components/shared/Modal.vue';

const namespace: string = 'auth';

@Component<OrderModificationRequestModal>({
	components: {
		Modal
	}
})
export default class OrderModificationRequestModal extends Vue {
	@Action('submitModificationRequest', { namespace }) private submitModificationRequestAction!: (payload: OrderModificationRequestPayload) => Promise<OrderModificationRequest>;
	@Prop({ type: Boolean, required: true }) isOpen!: boolean;
	@Prop({ type: String, required: true }) orderId!: string;

	private requestDetails: string = '';
	private submitting: boolean = false;

	private handleClose(): void {
		this.requestDetails = '';
		this.$emit('close');
	}

	private async handleSubmit(): Promise<void> {
		if (!this.requestDetails.trim()) {
			this.$toasted.show(this.$t('profile.scheduled_orders.order_modification_request_modal.empty_error'), { type: 'error', position: 'top-center' }).goAway(5000);
			return;
		}

		this.submitting = true;

		try {
			const newRequest = await this.submitModificationRequestAction({
				order_id: this.orderId,
				request_details: this.requestDetails.trim(),
				status: 'pending'
			});
			// Need a slight delay here and $nextTick() doesn't delay long enough
			setTimeout(() => {
				this.requestDetails = '';
				this.$toasted.show(this.$t('profile.scheduled_orders.order_modification_request_modal.success'), { type: 'success', position: 'top-center' }).goAway(5000);
				this.$emit('submit', newRequest);
			});
		}
		catch (error) {
			this.$toasted.show(this.$t('profile.scheduled_orders.order_modification_request_modal.error'), { type: 'error', position: 'top-center' }).goAway(5000);
		}
		finally {
			this.submitting = false;
		}
	}
}
